import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import { getFormValues } from 'redux-form'
import { WidgetActions } from '../../reducers/widget/actionNames'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import {
  fireToastError,
  fireToastSuccess,
} from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { fetchWidget } from '../../models/Widget'
import updateWidget from '../../models/Widget/updateWidget'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'

function* saveWidget() {
  const values = yield Effects.select(getFormValues('widgetConfig'))
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateWidgets)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, updateWidget),
      ),
    ])

    const objectId = yield Effects.select(getUserObjectId)

    const settings: any = yield Effects.call(service, values, objectId)

    if (settings.length === 0 || settings[0].error) {
      yield Effects.put({
        type: WidgetActions.WidgetsSettingsRiseError,
      })
    } else {
      yield Effects.put({
        settings,
        type: WidgetActions.WidgetsSettingsAccepted,
      })
    }

    if (settings.length === 0 || settings[0].error) {
      yield put(fireToastError(i18n.t('BBO_2954_valid_url_notavailable')))
    } else {
      yield put(fireToastSuccess(i18n.t('user_settings_updated')))
    }
  } catch (e) {
    console.error(e)
  }
}

function* loadWidget() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchWidget)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchWidget),
      ),
    ])

    const objectId = yield Effects.select(getUserObjectId)

    if (!objectId) {
      yield Effects.delay(500)
      yield Effects.put({ type: WidgetActions.LoadWidgetsSettings })
      return ''
    }

    let settings = yield Effects.call(service, objectId)

    if (settings.length === 0) {
      settings = [{ new: true }]
    }
    yield Effects.put({
      settings,
      type: WidgetActions.WidgetsSettingsAccepted,
    })
  } catch (e) {
    yield Effects.put({
      settings: [{ new: true }],
      type: WidgetActions.WidgetsSettingsAccepted,
    })
    console.error(e)
  }
}

export default function* () {
  yield Effects.takeEvery(WidgetActions.SaveWidgetsSettings, saveWidget)
  yield Effects.takeEvery(WidgetActions.LoadWidgetsSettings, loadWidget)
}
